module.exports = __webpack_public_path__ + "img/p2.60a686c0.png";